import { IReqchangeCrocessTeacherIdParams } from './personal-service-list';
import { number } from 'echarts/core';
export enum EnumServiceFromTypes{
    app ='app',
    h5 = 'h5',
    pc = 'pc'
}

export enum  EnumbookingTaskStatus{
    unstart = 0,
    doing = 1,
    end = 2,
    canceled = 3
}

export enum  EnumfeedBackType{
    temporarySave = 0,
    submit = 1,
}
export enum  EnumServiceRecordLiveStatus{
    normal = 1,
    studentUnIn = 2,
    other = 4
}

// 直播：1-正常 2-学生未到 4-其他 电话： 1-正常 2-无人接听 3-空号 4-其他 5-已接通 6-未接通
export enum  EnumServiceRecordPhoneStatus{
    normal = 1,
    noAnswer = 2,
    emptyPhone = 3,
    other = 4,
    readyConnect= 5,
    notConnect = 6
}
//沟通记录类型 1-直播记录 2-电话记录 3-提醒记录 4-取消课程记录 5-面授
export enum  EnumRecordTypes{
    cancelKe = 0,
    live = 1,
    phone = 2,
    remind = 3,
    cancel = 4,
    face = 5
}
//电话的几种状态
export enum  EnumCallStatus{
    unStart = 0,//未开始电话
    callUpIng = 1,//拨号中
    callSaying = 2,//通话中
    callHangUp = 3, //电话已挂断
    lostConnection = 4 //被挤下线
}
//私教评价结果 1、非常满意 2、不满意 3、满意 5、差评 6、一般 4、旧的测评评价，现在不展示
export enum  EnumIsLike{
    greatSatisfaction  = 1,
    unSatisfaction = 2,
    satisfaction = 3,
    old = 4,
    bad = 5,
    normal = 6
}
//私教评价结果
export enum  EnumIsLikeNew{
    bad = 1,// 差评
    not = 2, //不满意
    normal = 3, //一般
    great= 4,//满意
    verygood= 5//很满意
}
// 解决问题
export enum  EnumResolveResult{
    unResolve = 1,
    resolved = 2,
    exceedExpect = 3
}
export enum  EnumTeachAttitude{
    bad = 1,
    normal = 2,
    good = 3
}
//进入直播间按钮状态  0可以进入（开播前15分内） 1未开始（开播前15分前） 2迟到 3已结束 4没有权限
export enum  EnumEntryLiveStatus{
    canEntry = 0,
    notEntryBefore = 1,
    notEntryAfter = 2,
    end = 3,
    notAutho = 4,
}

//课程结束服务方式 服务类型 100529222 直播 100529221 电话 2000333 报备
export enum  EnumServiceTypeReal{
    live = 100529222,
    phone = 100529221,
    report = 2000333,
      face = 100529223
}
export interface ILivingRoomInfo{
    broadcastRoomUrl:string,                //类型：Mixed  必有字段  备注：直播间地址
    startTime:string,                //类型：Mixed  必有字段  备注：开始时间
    endTime:string,                //类型：Mixed  必有字段  备注：结束时间
    isShow:number,                //类型：Mixed  必有字段  备注：是否可以进入直播间 0可以进入 1未开始 2迟到 3已结束 4没有权限
    liveStatus:number,                //类型：Mixed  必有字段  备注：直播是否结束 0表示未开始，1表示进行中，2表示异常，3表示已完成
    broadcastRoomCode:string,                //类型：String  必有字段  备注：直播房间号
    isPlayback:boolean,                //类型：Boolean  必有字段  备注：是否有回放
    enterPlaybackPath:string                //类型：String  必有字段  备注：回放地址
}
export interface IactualServiceRecordInfo{
    actualStartTime:string,                //类型：Mixed  必有字段  备注：实际任务开始时间
    actualEndTime:string,                //类型：Mixed  必有字段  备注：实际任务结束时间
    totalServiceTime:number,                //类型：Mixed  必有字段  备注：服务总时长
    actualTotalServiceTime:number                //类型：Mixed  必有字段  备注：实际服务时长
    processServiceMode:number,//服务类型 100529222 直播 100529221 电话 2000333 报备
}

export interface IteacherServiceRecordsItem{
    recordType:number,                //类型：Number  必有字段  备注：沟通记录类型 1-直播记录 2-电话记录 3-提醒记录 4-取消课程记录
    createdBy:number,                //类型：Number  必有字段  备注：创建人Id
    createdByName:string,                //类型：String  必有字段  备注：创建人姓名
    classState:number,                //类型：Number  必有字段  备注：上课状态 直播：1-正常 2-学生未到 4-其他 电话： 1-正常 2-无人接听 3-空号 4-其他
    content:string,                //类型：String  必有字段  备注：记录与原因
    remindNumber:number,               //类型：Number  必有字段  备注：第几次提醒
    createdAt:string
}

export interface IEvaluationReportInfo{
    chapterName:string,                //类型：String  必有字段  备注：章名称
    sectionName:string,                //类型：String  必有字段  备注：节名称
    remark:string,                //类型：String  必有字段  备注：学员备注
    sourcesType:string,                //类型：String  必有字段  备注：是否来自测评
    evaluationPath:string               //类型：String  必有字段  备注：测评报告地址
}
export interface IResBookingDetail{
    id:number,//类型：Number  必有字段  备注：主键
    bookingId:number,                //类型：Number  必有字段  备注：预约详情id
    startTime:string,                //类型：String  必有字段  备注：服务开始时间
    newEvaluation:number,
    endTime:string,                //类型：String  必有字段  备注：服务结束时间
    teacherId:string|number,                //类型：Mixed  必有字段  备注：老师id
    teacherName:string,                //类型：Mixed  必有字段  备注：老师名称
    projectId:number,                //类型：Number  必有字段  备注：项目id
    projectName:string,                //类型：String  必有字段  备注：项目名称
    subjectId:number,                //类型：Number  必有字段  备注：科目id
    subjectName:string,                //类型：String  必有字段  备注：科目名称
    twoSubjectId:number,                //类型：Number  必有字段  备注：二级科目id
    twoSubjectName:string,                //类型：String  必有字段  备注：二级科目名称
    serviceTeamId:number,                //类型：Number  必有字段  备注：团队id
    serviceTeamName:string,                //类型：Mixed  必有字段  备注：团队名称
    sourcesType:number,                //类型：Number  必有字段  备注：预约类型 0-教研 1-测评
    isCivil:string,                //类型：String  必有字段  备注：是否为公考团队 0-否 1-是
    civilServant:number,
    serviceType:number,                //类型：Mixed  必有字段  备注：上课方式
    tutorDirection:string,                //类型：String  必有字段  备注：辅导方向
    objectives:string,                //类型：String  必有字段  备注：考试目标
    description:string,                //类型：String  必有字段  备注：问题描述
    memberImage:string,                //类型：String  必有字段  备注：图片
    status:number,                //类型：Number  必有字段  备注：任务状态 0未开始 / 1上课中 / 2已结束 / 3已取消
    livingRoom: ILivingRoomInfo,
    supportTeacherCancel:number,                //类型：Number  必有字段  备注：是否支持老师取消：0否，1是
    supportReport:number,                //类型：Mixed  必有字段  备注：是否支持反馈报告：0否，1是
    submitSupportReport:number,                //类型：Mixed  必有字段  备注：反馈报告是否提交：0否，1是
    submitLike: number,                //类型：Mixed  必有字段  备注：学员评价是否提交: 0否，1是
    bookingNum:string,                 //类型：String 必有字段  备注：预约周期
    remark: string,                    //备注
    createTime:string,                //类型：String  必有字段  备注：任务提交时间
    actualServiceRecord?:IactualServiceRecordInfo,//获取实际服务记录\
    teacherServiceRecords?: IteacherServiceRecordsItem[], //类型：Array  可有字段  备注：老师服务记录
    clickNotContact:boolean,                //类型：Boolean  必有字段  备注：联系不上 false-没点过 true-点过
    remindStatus:number,                //类型：Number  必有字段  备注：0 允许发送提醒 1 已超过提醒次数，不能再次发送 2接近上课，不能发送提醒 3课程已结束，不能发送提醒
    evaluationReport: IEvaluationReportInfo,
    reportEnd:boolean, //是否报备结束
    reserveMobile: string,              //类型：String  必有字段  备注：私教预约手机号
	reserveMobileMd5: string,
	reserveMobileCipher: string,
    managerName: string,
    hasPlayback:boolean,
    memberExams?: [],  //学员考季信息
    reportRecord?: {
        userId: number
        userName:string
        completeTime:string
        certFiles?: string[]
    }
    evaluationReply:number //回复学员状态
    sourcesId: any
}

export interface IResMemberDetail{
    memberId:number,                //类型：Number  必有字段  备注：学员id
    realName:string,                //类型：String  必有字段  备注：姓名
    mobile:string,                //类型：String  必有字段  备注：手机号
	mobileCipher: string,
	mobileMd5: string,
	mobileText: string,
    onlineMemberId:number,                //类型：Number  必有字段  备注：网校id
    email:string,                //类型：String  必有字段  备注：邮箱
    sex:number,                //类型：Number  必有字段  备注：性别
    nickName:string,                //类型：String  必有字段  备注：昵称
    transferorName:string,                //类型：String  必有字段  备注：无
    isAuth:number,                //类型：Number  必有字段  备注：是否认证
    memberDetailId:number,                //类型：Number  必有字段  备注：学员详情id
    birthday:string,                //类型：String  必有字段  备注：生日
    overseasName:string,                //类型：Mixed  必有字段  备注：海外联系人
    overseasMobile:string,                //类型：String  必有字段  备注：海外手机号
	overseasMobileCipher: string,
	overseasMobileMd5: string,
	overseasMobileText: string,
    nationality:number,                //类型：Number  必有字段  备注：国籍
    emergencyContactName:string,                //类型：String  必有字段  备注：紧急联系人
    emergencyContactPhone:string,                //类型：String  必有字段  备注：紧急联系手机号
	emergencyContactPhoneCipher: string,
	emergencyContactPhoneMd5: string,
	emergencyContactPhoneText: string,
    address:string,                //类型：String  必有字段  备注：地址
    city:string,                //类型：String  必有字段  备注：城市
    province:string,                //类型：String  必有字段  备注：省份
    relationshipLevel:number,                //类型：Number  必有字段  备注：关系等级
    contactTime:string,                //类型：Mixed  必有字段  备注：联系时间
    referee:string,                //类型：String  必有字段  备注：推荐人
    recommendedTime:string,                //类型：Mixed  必有字段  备注：推荐时间
    wechatNumber:string,                //类型：String  必有字段  备注：微信号
    qqNumber:string,                //类型：String  必有字段  备注：QQ号
    documentType:number,                //类型：Number  必有字段  备注：证件类型
    documentNumber:string,                //类型：String  必有字段  备注：证件号码
    companyName:string,                //类型：String  必有字段  备注：公司名称
    companyDepartment:string,                //类型：String  必有字段  备注：公司部门
    companyNature:string,                //类型：String  必有字段  备注：公司职位
    companyEmail:string,                //类型：String  必有字段  备注：公司邮件
    schoolName:string,                //类型：String  必有字段  备注：学校
    collegeId:number,                //类型：Number  必有字段  备注：大学
    professional:string,                //类型：String  必有字段  备注：专业
    collegeMajorClass:number,                //类型：Number  必有字段  备注：专业班级
    schoolHighestEducation:number,                //类型：Number  必有字段  备注：最高学历
    schoolEnterTime:number,                //类型：Number  必有字段  备注：入学年份
    remark:string,                //类型：String  必有字段  备注：备注
    major:string,                //类型：String  必有字段  备注：专业（自助入籍）
    graduateDate:string,                //类型：String  必有字段  备注：毕业年月（自助入籍）
    interestProject:string,                //类型：String  必有字段  备注：感兴趣项目（自助入籍）
    futurePlan:string,                //类型：String  必有字段  备注：为了计划（自助入籍）
    workChance:number,                //类型：Number  必有字段  备注：工作机会
    jobStatus:number,                //类型：Number  必有字段  备注：在职状态0：在职1：在校2：待业
    contactPhone:string,                //类型：String  必有字段  备注：联系手机号
    defaultContactType:number,                //类型：Number  必有字段  备注：默认联系类型（0：无1：本人2：紧急联系3：海外联系4：联系人
    contactList: {
        id:number,                //类型：Number  必有字段  备注：主键id
        memberId:number,                //类型：Number  必有字段  备注：教务学员id
        name:string,                //类型：String  必有字段  备注：联系人
        mobile:string,                //类型：String  必有字段  备注：联系手机号
        isDefault:number               //类型：Number  必有字段  备注：是否默认联系方式（0：否1：是））
    }[],
    targetSchoolId:string,                //类型：String  必有字段  备注：目标学校ID
    targetCollegeId:number,                //类型：Number  必有字段  备注：目标学院ID
    targetProfessional:string,                //类型：String  必有字段  备注：目标专业
    enrollSchoolId:string,                //类型：String  必有字段  备注：报名学校ID
    enrollCollegeId:number,                //类型：Number  必有字段  备注：报名学院ID
    enrollProfessional:string,                //类型：String  必有字段  备注：报名专业ID
    admissionSchoolId:string,                //类型：String  必有字段  备注：录取学校ID
    admissionCollegeId:number,                //类型：Number  必有字段  备注：录取学院ID
    admissionProfessional:string,                //类型：String  必有字段  备注：录取专业ID
    admissionScore:string,                //类型：String  必有字段  备注：录取分数
}

export interface IfeedbackFiles{
    name:string,
    path:string
}
export interface IResFeedBackReport{
    id:number,                //类型：Number  必有字段  备注：主键
    summary:string,                //类型：String  必有字段  备注：内容
    suggest:string,                //类型：String  必有字段  备注：建议
    startTime:string,                //类型：String  必有字段  备注：开始时间
    endTime:string,                //类型：String  必有字段  备注：结束时间
    counselingSubjectId:number,                //类型：Number  必有字段  备注：科目id
    counselingSubjectName:string,                //类型：String  必有字段  备注：科目名称
    feedbackFiles:IfeedbackFiles[],
    commit:number              //类型：Number  必有字段  备注：是否提交 0- 没有 1- 已提交
}

export interface IReqPushCallId{
    callId:string|number,
    processId:string|number,
    callCenterType:string,//1、ob，2、阿里CC，3、天润，4、企点（腾讯），5、七陌，6、FBOCC
    callExt:string|number,
    callerNo:string|number,
    answerNo:string|number,
    callStatus:0|1

}

export interface IReqHangupCallRecord{
    acid:string, //录音id，通话记录查询需要的字段
    called:string,//被叫号码
    caller:string,//主叫号码
    connId:string,//通话id
    hangupTime:number,//挂断时间
    id:number|string
}

export interface IResStudentAppraisal{
    appraisalTime:string,                //类型：String  可有字段  备注：评价时间
    isLike:number,                //类型：Number  可有字段  备注：is_like 评价等级:1、非常满意 2、不满意 3、满意 5、差评 6、一般 4、旧的测评评价，现在不展示
    resolveResult:number,                //类型：Number  可有字段  备注：问题解决：1没解决，2解决了，3超过预期
    teachAttitude:number,                //类型：Number  可有字段  备注：私教态度：1不好，2一般，3很赞
    studentComment:string,                //类型：String  可有字段  备注：评价内容
    contentValue:number,                //类型：Number  可有字段  备注：内容价值
    teachingAttitude:number,                //类型：Number  可有字段  备注：教学态度
    networkQuality:number,                //类型：Number  可有字段  备注：网络质量
    evaluationSource:number               //类型：Number  必有字段  备注：评价来源 0-默认教研 1-测评
}

export interface IRequpdateCallRecord{
    callId:string|number,
    processId:string|number,
    callCenterType:string,//1、ob，2、阿里CC，3、天润，4、企点（腾讯），5、七陌，6、FBOCC
    callExt:string|number,
    callerNo:string|number,
    answerNo:string|number
    callStatus:number
}

export interface IReqGetStudyRecord {
    'serviceTeamId':number|string,
    'memberId':number|string,
    'pageNum':number|undefined,
    'pageSize':number|undefined
}